import React, { Component } from 'react';

export class NumericCellEditorAllowNegative extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = {
            numValue: this.props.node.data[this.props.colDef.field] ,
        }
    }

    onKeyPress(e) {
       // const val= this.state.numValue;
       if (e.which != 46 && e.which != 45 && e.which != 46 &&
        !(e.which >= 48 && e.which <= 57)) {
            e.preventDefault();
        }
        function isNumeric(e) {
            return /[^0-9]/.test(e.key);
        }

    }

    onKeyDown(event) {
        if (event.keyCode === 39 || event.keyCode === 37) {
            event.stopPropagation();
        }
    }

    afterGuiAttached() {
        if (this.textInput) this.textInput.current.focus();
    };

    getValue() {
        return this.textInput.current.value;
    };

    componentDidMount() {
        this.textInput.current.addEventListener('keydown', this.onKeyDown);
    }

    render() {
        return (
            <input className="celleditorheight" onKeyPress={this.onKeyPress} 
            onChange={(e) => {
                //this.props.node.setDataValue(this.props.colDef.field, selected.label);
                //this.props.node.setDataValue(this.props.colDef.field + "_Id", selected.value);
                this.props.node.setDataValue(this.props.colDef.field, e.target.value);

            }}
             ref={this.textInput} defaultValue={this.props.value}/>
        );
    }
}